import React, { Dispatch, SetStateAction } from 'react'
import { Button, Card, List, Radio, Select, Space, Typography } from "antd";
import { ProductVersionModel } from '../../../models/product-interface';
import { SupportTier } from '../../../models/support-tier-interface';
import { RatePlan } from '../../../models/rate-plan-interface';
import { ProductRatePlan } from '../../../models/product-rate-plan-interface';

const { Title } = Typography

type Props = {
  selectedSupportTierId: number | null;
  setSelectedSupportTierId: Dispatch<SetStateAction<number | null>>;
  allSupportTiers: SupportTier[];
  disabled: boolean;
}

const SupportRadioList: React.FC<Props> = ({
  selectedSupportTierId,
  setSelectedSupportTierId,
  allSupportTiers,
  disabled
}) => {

  return <Radio.Group
    className="full-width"
    value={selectedSupportTierId} 
    onChange={(e) => {
      setSelectedSupportTierId(e.target.value)
    }}
    disabled={disabled}
  >
    <List
      dataSource={allSupportTiers}
      renderItem={(item) => (
        <List.Item>
          <Radio value={item.id} disabled={disabled}>
            <Title level={5}>
              {item?.name}
            </Title>
            <div>
              {item?.days}
            </div>
            <div>
              {item?.timeString}
            </div>
            <div>
              {`${item?.phone ? "Phone" : ""} ${item?.phone && item?.email ? "&" : ""} ${item?.email ? "Email" : ""}`}
            </div>
          </Radio>
        </List.Item>
      )}
    />
  </Radio.Group>
}

export default SupportRadioList;